<template>
  <div>
    <template v-if="place">
      <p class="page-subtitle">Primo contatto</p>
      <div class="row mx-0 mb-2">
        <div class="radio d-flex">
          <label class="mb-0">
            <input
              type="radio"
              name="o3"
              :value="place.newCustomer"
              :disabled="disabled"
              :checked="place.newCustomer"
              @input="onRadioChanged($event.target.value)"
            />
            <span class="cr">
              <i class="cr-icon fa fa-circle"></i>
            </span>
          </label>
          <p class="mb-auto clickable" @click="onRadioChanged(true)">
            Nuovo cliente
          </p>
        </div>
        <div class="radio text-right d-flex ml-3">
          <label>
            <input
              :disabled="disabled"
              type="radio"
              name="o3"
              :checked="!place.newCustomer"
              @input="onRadioChanged(!$event.target.value)"
              :value="place.newCustomer"
            />
            <span class="cr">
              <i class="cr-icon fa fa-circle"></i>
            </span>
          </label>
          <p class="mb-auto clickable" @click="onRadioChanged(false)">
            Cambio gestione
          </p>
        </div>
      </div>
      <div class="form-group row" v-if="!place.newCustomer">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Precedentemente gestito da</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="['previous_business_name']"
          />
          <inline-editor
            inputClasses="text-left borderless p-0 w-100"
            :disabled="disabled"
            :value="place.previousBusinessName"
            class="ml-auto my-auto w-100"
            placeholder="precedente gestione"
            @change="onDataUpdated"
            :dataKeys="['previous_business_name']"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Data acquisizione</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <p class="mb-0">{{ place.createdAt | moment("DD/MM/YYYY") }}</p>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >In target*</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="['is_in_target']"
          />
          <custom-select
            class="max-size"
            :placeholder="'Seleziona se in target...'"
            :items="booleanOptions"
            :disabled="disabled"
            @change="onDataUpdated"
            :dataKeys="['isInTarget']"
            :idSelected="
              place.isInTarget == undefined ? '' : place.isInTarget ? '1' : '0'
            "
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Nome locale*</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="['name']"
          />
          <inline-editor
            inputClasses="text-left borderless p-0 w-100"
            :disabled="disabled"
            :value="place.name"
            class="ml-auto my-auto w-100"
            placeholder="nome locale"
            @change="onDataUpdated"
            :dataKeys="['name']"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Indirizzo*</label
        >
        <div class="col-lg-10 col-md-8 col-sm-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="[/^address\..*$/]"
          />
          <inline-places-autocomplete
            class="ml-auto my-auto w-100"
            :disabled="disabled"
            :options="{ country: 'it' }"
            @selected="onDataUpdated"
            :dataKeys="['google_maps_location']"
            :value="place.address.fullAddress"
          />
        </div>
        <div
          class="checkbox col-lg-4 col-md-4 offset-md-4 offset-lg-2"
          v-if="!place.address.streetNumber"
        >
          <label class="mb-0">
            <input
              type="checkbox"
              name="o3"
              v-model="place.address.missingStreetNumber"
              :disabled="disabled"
              :checked="place.address.missingStreetNumber"
              @input="onStreetNumberPresenceChanged"
            />
            <span class="cr">
              <i class="cr-icon fa fa-check"></i>
            </span>
            Numero civico mancante
          </label>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Provenienza</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="['place_recommendation_type']"
          />
          <place-recommendation-type-select
            class="max-size"
            :disabled="disabled"
            @change="onDataUpdated"
            :dataKeys="['place_recommendation_type_id']"
            :idSelected="place.placeRecommendationTypeId"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Tipologia prevalente</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="['place_type']"
          />
          <place-type-select
            class="max-size"
            :disabled="disabled"
            @change="onDataUpdated"
            :dataKeys="['placeTypeId']"
            :idSelected="place.placeTypeId"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Stato attività</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="['opening_status']"
          />
          <custom-select
            class="max-size"
            :placeholder="'Seleziona stato attività...'"
            :items="openingStatuses"
            :disabled="disabled"
            @change="onDataUpdated"
            :dataKeys="['openingStatus']"
            :idSelected="place.openingStatus"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Proprietario</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="['place_ownership_type']"
          />
          <place-ownership-type-select
            class="max-size"
            :disabled="disabled"
            @change="onDataUpdated"
            :dataKeys="['placeOwnershipTypeId']"
            :idSelected="place.placeOwnershipTypeId"
          />
        </div>
      </div>
      <div class="form-group row" v-if="place.openingStatus != 'new_business'">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Fornitore attuale</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="['competitor']"
          />
          <competitor-select
            class="max-size"
            @change="onDataUpdated"
            :disabled="disabled"
            :dataKeys="['competitorId']"
            :idSelected="place.competitorId"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Giorni di chiusura</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="['closing_days']"
          />
          <inline-multi-select
            class="max-size"
            :disabled="disabled"
            :options="weekDays"
            :value="place.closingDays"
            @change="onClosingDaysUpdated"
            :dataKeys="['closingDays']"
          />
        </div>
      </div>

      <p class="page-subtitle mt-5 mb-3">Persona di riferimento</p>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Nome</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="['contact.first_name']"
          />
          <inline-editor
            inputClasses="text-left borderless p-0 w-100"
            :disabled="disabled"
            :value="place.contact.firstName"
            class="ml-auto my-auto"
            placeholder="Nome"
            :dataKeys="['contact', 'firstName']"
            @change="onDataUpdated"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Cognome</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="['contact.last_name']"
          />
          <inline-editor
            inputClasses="text-left borderless p-0 w-100"
            :disabled="disabled"
            :value="place.contact.lastName"
            class="ml-auto my-auto"
            placeholder="Cognome"
            :dataKeys="['contact', 'lastName']"
            @change="onDataUpdated"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Telefono</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="['contact.phone']"
          />
          <inline-editor
            inputClasses="text-left borderless p-0 w-100"
            :disabled="disabled"
            :value="place.contact.phone"
            class="ml-auto my-auto"
            placeholder="Telefono"
            :dataKeys="['contact', 'phone']"
            @change="onDataUpdated"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
          >Ruolo</label
        >
        <div class="col-lg-10 col-md-8 col-12 my-auto">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="['contact.role']"
          />
          <inline-editor
            inputClasses="text-left borderless p-0 w-100"
            :value="place.contact.role"
            class="ml-auto my-auto"
            placeholder="Ruolo"
            :dataKeys="['contact', 'role']"
            @change="onDataUpdated"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import InlineEditor from "components/InlineEditor.vue";
import { Place } from "models";
import PlaceTypeSelect from "components/PlaceType/Select.vue";
import CustomSelect from "components/Place/CustomSelect.vue";
import PlaceRecommendationTypeSelect from "components/PlaceRecommendationType/Select.vue";
import PlaceOwnershipTypeSelect from "components/PlaceOwnershipType/Select.vue";
import CompetitorSelect from "components/Competitor/Select.vue";
import InlinePlacesAutocomplete from "components/Google/InlinePlacesAutocomplete.vue";
import InlineMultiSelect from "components/InlineMultiSelect.vue";

@Component({
  components: {
    InlineMultiSelect,
    InlinePlacesAutocomplete,
    InlineEditor,
    PlaceTypeSelect,
    CustomSelect,
    PlaceRecommendationTypeSelect,
    PlaceOwnershipTypeSelect,
    CompetitorSelect,
  },
})
export default class PlaceData extends Vue {
  @Prop({ required: true })
  place: Place;

  @Prop({ default: true })
  disabled: boolean;

  weekDays = [
    { id: "monday", name: "Lunedì" },
    { id: "tuesday", name: "Martedì" },
    { id: "wednesday", name: "Mercoledì" },
    { id: "thursday", name: "Giovedì" },
    { id: "friday", name: "Venerdì" },
    { id: "saturday", name: "Sabato" },
    { id: "sunday", name: "Domenica" },
    { id: "none", name: "Nessuno" },
  ];

  openingStatuses: Array<{ name: string; id: string }> = [
    { name: "Nuova apertura", id: "new_business" },
    { name: "Attività esistente", id: "existing_business" },
  ];

  booleanOptions: Array<{ name: string; id: number }> = [
    { name: "Sì", id: 1 },
    { name: "No", id: 0 },
  ];

  onDataUpdated(data) {
    this.$emit("updated", data);
  }

  onClosingDaysUpdated(newData) {
    if (
      newData.closingDays &&
      newData.closingDays.length > 1 &&
      newData.closingDays.includes("none")
    ) {
      if (this.place.closingDays.includes("none")) {
        this.place.closingDays = newData.closingDays.filter(
          (el) => el != "none",
        );
      } else {
        this.place.closingDays = ["none"];
      }
    }

    this.$emit("updated", newData);
  }

  onRadioChanged(value) {
    if (this.disabled) return;
    this.place.newCustomer = value;
    this.$emit("updated", { newCustomer: value ? "1" : "0" });
  }

  onStreetNumberPresenceChanged() {
    this.$emit("updated", {
      address: {
        missingStreetNumber: !this.place.address.missingStreetNumber
          ? "1"
          : "0",
      },
    });
  }
}
</script>

<style scoped>
.max-size {
  max-width: 18rem;
}
</style>
